import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { Log } from './log.entity'

export class LogsRepository extends BaseRepository<Log> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.paymentApiUrl + '/logs', token, cache)
    }
}
